export default __webpack_public_path__ + "static/media/VChurchilOpen.9fd461db.jpg";